'use client'

import styles from './Instituicoes.module.css';
import instituicoesData from '../../jsons/Instituicoes.json';


const Instituicoes = () => {
  return (
    <section className={styles.instituicoes} aria-labelledby="instituicoes-title">
      <h2 id="instituicoes-title" className="hidetext">Instituições</h2>
      <div className="uiContainer">
        <h2 className={styles.titleArea} tabIndex={0}>
          São mais de <strong>950 Instituições</strong> que utilizam a Biblioteca Virtual
        </h2>
        <ul className={styles.containerLogos}>
          {instituicoesData.map((instituicao, index) => (
            <li key={index} className={styles.itemLogo}>
              <img
                src={instituicao.src}
                alt={instituicao.alt}
                loading="lazy"
                width={110}
                height={85}
                tabIndex={0}
              />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Instituicoes;